import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error?.config;
    const url = cfg?.url || "";
    if (error?.response?.status !== 401 || cfg?._retried || url.includes("/auth/")) throw error;
    cfg._retried = true;
    refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
    await refreshing;
    return api(cfg);
  },
);

export const errorText = (err) => {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg).filter(Boolean).join(" ").replace(/^Value error, /, "");
  return "Something went wrong. Please try again.";
};

export const thumbUrl = (id) => `${API}/films/${id}/thumbnail`;
